import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_SEO_SETTINGS = `${URL_RETAILER_SCOPED}/seo-settings`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'seo-settings'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'seo-settings': URL_SEO_SETTINGS,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
